import { withPrefix } from 'gatsby';

export const NOCAMPINGNOCRY = withPrefix('/icons/nocampingnocry.svg');
